<template>
  <div>
    <v-card>
      <!-- <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          Button Adicionar
          <v-col cols="12" md="9">
            <v-btn small color="info" class="mr-4" 
                @click="[$router.push({name: 'AdministratorSystemNotificationNew'}), showDialog()]"
              >
                <v-icon left>mdi-plus</v-icon>
                Adicionar Notificação
              </v-btn>
          </v-col>
          End Button Adicionar

          Search Table
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
          End Search Table
        </v-row>
      </div> -->
      <v-divider></v-divider>

      <!-- Table -->
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:top>
          <!-- <div class="pa-2 d-print-none">
          </div> -->
          <v-row no-gutters class="align-center pa-4 d-print-none">
            <!-- Button Adicionar -->
            <!-- <v-col cols="12" md="9">
              <v-btn color="info" class="mr-4" 
                  @click="[$router.push({name: 'AdministratorSystemNotificationAdd'}), showDialog()]"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t("newMessage") }}
                </v-btn>
            </v-col> -->
            <!-- End Button Adicionar -->

            <!-- Search Table -->
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
            <!-- End Search Table -->
          </v-row>
        </template>
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>

        <!--  -->
        <template v-slot:item.message="{ item }">
          <p
            v-html="item.message"
            style="
              max-width: 15ch;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          ></p>
        </template>
        <!--  -->

        <!--  -->
        <template v-slot:item.viewed="{ item }">
          <v-chip :color="item.viewed.color" small>{{
            item.viewed.text
          }}</v-chip>
        </template>
        <!--  -->

        <!--  -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="readNotification(item)"
              >
                <v-icon>mdi-magnify-plus-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("toView") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <!-- End Table -->
    </v-card>
    <!-- End Datatable -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "administrator-dashboard-notification",

  data: () => ({
    search: "",
    data: [],
  }),
  computed: {
    items() {
      return [
        { text: this.$t("sgaNotifications"), status: 1, color: "green" },
        { text: this.$t("yourNotifications"), status: 0, color: "purple" },
      ];
    },
    headers() {
      return [
        { text: "Nº", value: "id" },
        { text: this.$t("subject"), value: "subject" },
        { text: this.$t("date"), value: "date_notification" },
        // { text: "Mensagem", value: "message" },
        { text: this.$t("status"), value: "viewed" },
        { text: this.$t("actions"), value: "action" },
      ];
    },
  },

  async mounted() {
    const request = await this.$request.get(
      "/administrator/notifications/list"
    );
    request.dados.forEach((item) => {
      if (/\[|\]/.test(item.message)) {
        var regex = /(\[)(.*)(\])/;
        item.subject = regex.exec(item.message)[2];
      } else {
        item.subject = "sem assunto";
      }
      item.date_notification = new Date(
        item.date_notification
      ).toLocaleDateString();
      item.viewedStatus = item.viewed == "1";
      item.viewed = {
        text: item.viewed == "1" ? this.$t("read") : this.$t("notRead"),
        color: item.viewed == "1" ? "success" : "error",
      };
    });
    this.data = request.dados;
  },

  methods: {
    showDialog() {
      this.$store.commit("showDialog", true);
    },
    readNotification(item) {
      if (!item.viewedStatus) {
        this.setNotificationToRead(item.id);
        this.$store.commit("minusOneNotification");
      }

      this.$router.push({
        name: "AdministratorSystemNotification",
        params: { id: item.id },
      });

      this.showDialog();
    },
    setNotificationToRead(notificationId) {
      this.data = this.data.map((item) => {
        if (notificationId === item.id) {
          return {
            ...item,
            viewedStatus: true,
            viewed: { text: this.$t("read"), color: "success" },
          };
        }

        return item;
      });
    },
  },
};
</script>
